import { render, staticRenderFns } from "./EditSelectedPartner.vue?vue&type=template&id=2a7ee5c0&scoped=true&"
import script from "./EditSelectedPartner.vue?vue&type=script&lang=js&"
export * from "./EditSelectedPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7ee5c0",
  null
  
)

export default component.exports